exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.places-email-generator.page-content {\n    max-width: 100%;\n}\n", ""]);

// exports
